import { Component, Input, OnInit } from "@angular/core";

@Component({
	selector: "caass-auto-point-school-table",
	templateUrl: "./auto-point-school-table.component.html",
	styleUrls: ["./auto-point-school-table.component.css"],
})
export class AutoPointSchoolTableComponent implements OnInit {
	constructor() {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.UpdateSchools();
	}
	ngOnChanges() {
		this.UpdateSchools();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() SelectedAutoPoint: any;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedSchool: any;
	lstSchool: any = [];

	//Filter lists

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "SchoolNumber", header: "School Number" },
		{ field: "SchoolName", header: "School Name" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	UpdateSchools() {
		this.lstSchool = [];

		this.loading = true;

		if (this.SelectedAutoPoint == null) {
			this.lstSchool = [];
		} else {
			this.lstSchool = this.SelectedAutoPoint.lstSchools;
		}

		this.loading = false;
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedSchool = val.data;
	}
	onRowUnselect(val) {
		this.SelectedSchool = null;
	}
	onRowDblClick(School) {
		this.SelectedSchool = School;
	}
	////////////////////////////////////////////
}
